<template>
  <i class="tkRightArrow" />
</template>

<script>
export default {
  name: 'TkRightArrow',
}
</script>

<style lang="scss">
.tkRightArrow {
  &::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    content: "";
    vertical-align: middle;
  }

  &::after {
    border-right: 2px solid;
    border-top: 2px solid;
    height: 5px;
    width: 5px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    content: "";
    vertical-align: middle;
    transform: rotate(45deg);
  }
}
</style>
